<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text mgr_15">
					Zone
				</em>
				<span class="int_type mgr_15">
					<select v-model="zone_code" class="tbl_select sm_int" style="width:80px;" @change="selectZoneCharges()">
						<option v-for="zone in zones" v-bind:value="zone.zone_code" v-bind:key="zone.zone_code">{{ zone.zone_code }}</option>
					</select>
				</span>
				<span class="int_type mgr_15">
					<select v-model="active_yn" class="tbl_select sm_int" @change="selectZoneCharges()">
						<option v-for="tag in this.$activeTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_tbl">
				<!-- <h4 class="inner_h4">Zone List</h4> -->
				<div class="fixed-table-container">
					<div class="table-wrapper">
						<table class="list_tbl tbl_pointer">
							<thead>
								<tr>
									<th style="text-align:center;width:10%;"><div class="th-text">Zone</div></th>
									<th style="text-align:center;width:10%;"><div class="th-text">To Weight</div></th>
									<th style="text-align:center;width:15%"><div class="th-text">Charge</div></th>
									<th style="text-align:center;width:10%;"><div class="th-text">Active</div></th>
									<th style="text-align:center;width:20%;"><div class="th-text" style="padding-left:30px;">Modified Date</div></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="zoneCharge in zoneCharges" v-bind:key="zoneCharge.to_freight" v-bind:class="{ on: zoneCharge.to_weight == selectedCharge.to_weight }" @click="selectRow(zoneCharge)">
									<td>{{ zoneCharge.zone_code }}</td>
									<td style="text-align:right;">{{ zoneCharge.to_weight }}</td>
									<td style="text-align:right;">{{ zoneCharge.charge | toCurrency }}</td>
									<td style="text-align:center;">{{ zoneCharge.active_yn }}</td>
									<td>{{ getModifiedDate(zoneCharge.crt_dt, zoneCharge.upd_dt) | moment('MM-DD-YYYY HH:mm:ss') }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div style="text-align:right;padding-top:5px;padding-right:10px;">Total Count : {{ zones.length | commaSeparated }}</div>

				<div class="view_bottom_bt">
					<a href="javascript:;" :class="mode == 'add' ? 'disable_bt' : 'gray_bt'" @click="add()">Add</a>
				</div>
			</div>

			<div class="right_tbl">
				<h4 class="inner_h4">{{ detailTitle }}</h4>
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:135px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>Zone</th>
							<td>
								<input type="text" v-model.trim="zoneCharge.zone_code" ref="zoneCharge" class="tbl_int sm_int" v-bind:disabled="true" />
							</td>
						</tr>
						<tr>
							<th>To Weight</th>
							<td><currency-input type="text" v-model.trim="zoneCharge.to_weight" class="tbl_int sm_int al_right" v-bind:disabled="mode == 'detail'" /></td>
						</tr>
						<tr>
							<th>Charge</th>
							<td><currency-input type="text" v-model.trim="zoneCharge.charge" class="tbl_int sm_int al_right" /></td>
						</tr>
						<tr>
							<th></th>
							<td>
								<label for="active_yn" style="margin-left:5px;"> <input type="checkbox" id="active_yn" v-model="zoneCharge.active_yn" true-value="Y" false-value="N" />Active</label>
							</td>
						</tr>
					</tbody>
				</table>

				<div class="view_bottom_bt" style="padding-top:15px;">
					<a href="javascript:;" :class="!isValid ? 'disable_bt' : 'search_bt'" @click="submit()">Save</a>
					&nbsp;<a v-if="false" href="javascript:;" :class="!isDeletable ? 'disable_bt' : 'gray_bt'" @click="del()">Delete</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectZoneList, apiSelectZoneChargeList, apiCheckZoneChargeExists, apiInsertZoneCharge, apiUpdateZoneCharge, apiDeleteZoneCharge } from '@/api/basicinfo/code.js';
import _ from 'lodash';
import '@/assets/css/table_box.css';

export default {
	data: function() {
		return {
			backUri: '/',
			zone_code: null,
			active_yn: 'Y',
			mode: null,

			zones: [],
			zoneCharges: [],
			selectedCharge: {},

			zoneCharge: {},
		};
	},
	computed: {
		detailTitle() {
			return this.mode == 'add' ? 'Add' : 'Detail';
		},
		isValid() {
			if (!this.zoneCharge.zone_code || !this.zoneCharge.to_weight || !this.zoneCharge.charge) return false;
			else return true;
		},
		isDeletable() {
			if (this.mode == 'detail' && this.selectedCharge) return true;
			else return false;
		},
		// sortedCodeTypes() {
		// 	return _.orderBy(this.$codeTypes, 'text', 'asc'); // 오름차순 :: asc
		// },
	},
	components: {},
	methods: {
		getModifiedDate(crt_dt, upd_dt) {
			return !upd_dt ? crt_dt : upd_dt;
		},
		async selectZones() {
			const { data } = await apiSelectZoneList();

			this.zones = data.zoneList;
			if (this.zones.length > 0) {
				this.zone_code = this.zones[0].zone_code;
				this.selectZoneCharges();
			}
		},
		async selectZoneCharges() {
			const { data } = await apiSelectZoneChargeList({ zone_code: this.zone_code, active_yn: this.active_yn });
			this.zoneCharges = data.zoneChargeList;
			if (this.zoneCharges.length > 0) this.selectRow(this.zoneCharges[0]);
			//console.log(data.zoneChargeList);
		},
		add() {
			this.mode = 'add';
			this.zoneCharge = {};
			this.zoneCharge.zone_code = this.zone_code;
			this.zoneCharge.active_yn = 'Y';

			this.selectedCharge = {};
		},
		async checkExists() {
			const { data } = await apiCheckZoneChargeExists(this.zoneCharge);
			return data.result;
		},
		async submit() {
			if (!this.isValid) return;

			if (!this.zoneCharge.to_weight) {
				this.$toast.error('Empty To Weight');
				return;
			}

			if (!this.zoneCharge.charge) {
				this.$toast.error('Empty Charge');
				return;
			}

			//console.log(this.code);
			var response;
			if (this.mode == 'add') {
				if (await this.checkExists()) {
					this.$toast.error('Duplicate Zone Charge');
					return;
				}
				response = await apiInsertZoneCharge(this.zoneCharge);
			} else {
				response = await apiUpdateZoneCharge(this.zoneCharge);
			}
			var data = response.data;

			if (data.result) {
				this.$toast.success('Saved successfully');
				if (this.mode == 'add') {
					this.zoneCharges.push(this.zoneCharge);
				}
				Object.assign(this.selectedCharge, this.zoneCharge);
			} else {
				this.$toast.error(data.msg);
			}

			this.mode = 'detail';
		},
		// setSelectedCharge() {
		// 	this.selectedCharge.zone_code = this.zoneCharge.zone_code;
		// 	this.selectedCharge.to_weight = this.zoneCharge.to_weight;
		// 	this.selectedCharge.charge = this.zoneCharge.charge;
		// 	this.selectedCharge.active_yn = this.zoneCharge.active_yn;
		// },
		async del() {
			if (!this.isDeletable) return;

			if (confirm('Are you sure to delete?')) {
				const { data } = await apiDeleteZoneCharge(this.zoneCharge);

				if (data.result) {
					this.$toast.success('Deleted successfully');
					this.selectZones();
				} else {
					this.$toast.error('Failed');
				}
			}
		},
		selectRow(zoneCharge) {
			this.mode = 'detail';
			this.selectedCharge = zoneCharge;

			//console.log(zone);
			this.zoneCharge = _.cloneDeep(zoneCharge);
		},
	},
	created() {
		this.backUri = '/';

		//this.$store.sideIndex = 9;
		this.$store.commit('setSideIndex', 9);
		this.$store.commit('setSelectedMenu', 'nav_li_zone');
		this.$store.commit('setSubTitle', 'Basic Information -> Zone');

		//this.code_type = 'BK';
		this.selectZones();
	},
	mounted() {
		inputSelectOnClick();

		$('.table-wrapper').on('scroll', function() {
			if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
				//var $rows = $('#item_list tbody tr');
				var $rows = $('.list_table tbody tr');
				var lastActiveIndex = $rows.filter('.active:last').index();
				$rows.filter(':lt(' + (lastActiveIndex + 25) + ')').addClass('active');
			}
		});
	},
};
</script>

<style></style>
